<template>
    <div class="bg">
        <div class="componentTop" style="width:1200px:margin:auto;">
            <div class="componentText">预览课程</div>
            <!-- <div class="componentText">{{ courseDeatil.researchName }}</div> -->
        </div>
        <div class="bgbgbg">
            <div class="bgbgbgbgbgbg">
                <a-input-number
                    placeholder="设置过期时间"
                    enter-button="设置(天)"
                    :min="1"
                    v-model="search"
                    style="width:300px"
                />
                <a-button type="primary" @click="onSearch">
                    设置(天)
                </a-button>
            </div>
            <div class="bgbgbgbgbgbgbgbgbgbgbgbg">
                说明：以下是本课程测试的单点登录地址，仅供测试课程使用。可以设置过期时间，单位为天。不设置过期时间，默认为30天。
            </div>
            <a-table :columns="columns" :data-source="data" style="width:1200px;">
                <a slot="name" slot-scope="text">{{ text }}</a>
                <a slot="address" slot-scope="address" :href="address" target="_blank" style="width:880px;display: block;">{{ address }}</a>
            </a-table>
        </div>
    </div>
</template>

<script>
    const columns = [
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '测试地址',
            dataIndex: 'address',
            key: 'address',
            scopedSlots: { customRender: 'address' },
        },
    ];

    const data = [
        // {
        //     key: '1',
        //     name: 'John Brown',
        //     age: 'name',
        //     address: 'New York No. 1 Lake Park',
        //     tags: ['nice', 'developer'],
        // },
        // {
        //     key: '2',
        //     name: 'Jim Green',
        //     age: 42,
        //     address: 'London No. 1 Lake Park',
        //     tags: ['loser'],
        // },
        // {
        //     key: '3',
        //     name: 'Joe Black',
        //     age: 32,
        //     address: 'Sidney No. 1 Lake Park',
        //     tags: ['cool', 'teacher'],
        // },
    ];
    export default {
        data () {
            return {
                data: [],
                columns,
                search: '',
                courseDeatil: {},
            }
        },
        mounted(){

            this.http.get(this.apis.user.getTestAddrLists, {
                researchId: this.appUtils.getResearchId(),
            }).then(res => {
                console.log(res);
                this.data = [];
                let domain = window.location.origin;
                let nowDate = new Date();
                let nowDateTime = nowDate.getTime();
                let thisDateTime = nowDateTime + (parseInt(30)*86400000);
                for (let i in res.data){
                    let newObj = {};
                    newObj.key = i+1;
                    newObj.name = res.data[i].realname;
                    newObj.researchId = res.data[i].researchId;
                    newObj.groupId = res.data[i].groupId;
                    newObj.userId = res.data[i].userId;
                    let s = this.appUtils.getStudyUrlSign(res.data[i].userId,thisDateTime);
                    newObj.address =  window.location.origin + '/study' + '?userId=' + res.data[i].userId + '&exp=' + (new Date(thisDateTime)).getTime() + '&researchId=' + res.data[i].researchId + '&groupId=' + res.data[i].groupId + '&s=' + s;
                    this.data.push(newObj);
                }
            }).catch(err => {
                this.$message.error(err.message);
            })
            this.getResearchMessageById();
        },
        methods: {
            onSearch(){
                console.log(this.search);
                if (this.search){
                    let domain = window.location.origin;
                    let nowDate = new Date();
                    let nowDateTime = nowDate.getTime();
                    let thisDateTime = nowDateTime + (parseInt(this.search)*86400000);
                    for (let i in this.data){
                        let s = this.appUtils.getStudyUrlSign(this.data[i].userId,thisDateTime);
                        this.data[i].address = window.location.origin + '/study' + '?userId=' + this.data[i].userId + '&exp=' + (new Date(thisDateTime)).getTime() + '&researchId=' + this.data[i].researchId + '&groupId=' + this.data[i].groupId + '&s=' + s;
                    }
                    this.$message.success('设置时间完成，'+this.search+'天后过期');
                }
            },
            getResearchMessageById(){
                let url = this.apis.courseInfoSetting.getResearchMessageById + this.appUtils.getResearchId();
                this.http.get(url)
                .then(({data})=>{
                    this.courseDeatil = data;
                }).catch((err)=> {
                    console.log(err);
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    .bgbgbg{
        max-width: 1200px;
        margin: auto;
    }
    .bgbgbgbgbgbg{
        width: 500px;
        margin: 10px 0;
    }
    .bgbgbgbgbgbgbgbgbgbgbgbg{
        color: #999;
        text-align: left;
    }
    .componentTop{
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        padding: 25px 40px;
    }
    .componentText{
        font-size: 30px;
        color: #333333;
    }
</style>